import { FC, FormEvent, useState } from 'react'
import { Button } from '../components/ui/Button'
import { Panel } from '../components/ui/Panel'
import { PageHeader } from '../components/ui/PageHeader'

const CONTACT_ENDPOINT = 'https://formspree.io/f/xqejqyqj'

/** Contact page with a simple Formspree submission form. */
const Contact: FC = () => {
  const [submitted, setSubmitted] = useState(false)
  const [submitting, setSubmitting] = useState(false)
  const [error, setError] = useState<string | null>(null)

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    setSubmitting(true)
    setError(null)
    const data = new FormData(e.currentTarget)
    const res = await fetch(CONTACT_ENDPOINT, {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: data,
    })
    setSubmitting(false)
    if (res.ok) {
      setSubmitted(true)
    } else {
      setError('Something went wrong. Please try again or email us directly.')
    }
  }

  return (
    <div className='space-y-6'>
      <PageHeader
        title='Contact'
        subtitle='Reach us for questions about tickets, merch, press, partnerships.'
      />

      <Panel>
        {submitted ? (
          <div className='text-sm text-brand-azure/80'>
            <p className='text-brand-blue font-semibold'>Message received!</p>
            <p className='mt-1'>Thanks for getting in touch — we&apos;ll get back to you as soon as we can.</p>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className='grid gap-4 text-sm text-brand-azure/80'>
            <label className='grid gap-2'>
              Name
              <input
                className='rounded-xl bg-brand-azure/15 px-4 py-2 text-brand-azure ring-1 ring-black/50 shadow-[inset_0_1px_6px_rgba(0,0,0,0.45)]'
                name='name'
                required
                type='text'
                autoComplete='name'
              />
            </label>
            <label className='grid gap-2'>
              Email
              <input
                className='rounded-xl bg-brand-azure/15 px-4 py-2 text-brand-azure ring-1 ring-black/50 shadow-[inset_0_1px_6px_rgba(0,0,0,0.45)]'
                name='email'
                required
                type='email'
                autoComplete='email'
              />
            </label>
            <label className='grid gap-2'>
              Order Confirmation Number
              <input
                className='rounded-xl bg-brand-azure/15 px-4 py-2 text-brand-azure ring-1 ring-black/50 shadow-[inset_0_1px_6px_rgba(0,0,0,0.45)]'
                name='orderConfirmationNumber'
                type='text'
                placeholder='e.g. 2MA55307MN929232F — optional, for order enquiries'
              />
            </label>
            <label className='grid gap-2'>
              Message
              <textarea
                className='min-h-[120px] rounded-xl bg-brand-azure/15 px-4 py-2 text-brand-azure ring-1 ring-black/50 shadow-[inset_0_1px_6px_rgba(0,0,0,0.45)]'
                name='message'
                required
              />
            </label>
            {error && <p className='text-sm text-red-400'>{error}</p>}
            <Button variant='primary' size='md' type='submit' className='w-fit' disabled={submitting}>
              {submitting ? 'Sending…' : 'Send'}
            </Button>
          </form>
        )}
      </Panel>
    </div>
  )
}

export default Contact
